import { useEffect } from 'react';
import { notifyMissingGoogleClientIdToast } from '../utils/authConfigurationErrors';

/** Shows a top-right toast when `VITE_GOOGLE_CLIENT_ID` is not set (once per tab session). */
export function useAuthGoogleConfigToast(
  showError: (title: string, message?: string) => void,
): void {
  useEffect(() => {
    notifyMissingGoogleClientIdToast(showError);
  }, [showError]);
}
